






































import Vue, { PropType } from 'vue'
import { getNestedValue } from '@/util/helpers'
import { ValuationEdit, ValuationEditObject } from '@/types/store/valuation'
import { Coefficient } from '@/interfaces/report/coefficients'

export default Vue.extend({
  computed: {
    coefficients(): { [coeffKey: string]: boolean } {
      return this.$store.getters['valuationEdit/coefficients']
    },
    coefficientValues(): { [coeffKey: string]: boolean } {
      return getNestedValue(
        this.$store.getters['valuationEdit/data'],
        ['coefficientsValues'],
        {}
      )
    },
    coefficientEdits(): ValuationEdit | undefined {
      const valuationEdits = this.$store.getters['valuationEdit/edits']
      return getNestedValue(valuationEdits, ['coefficients'], undefined)
    },
    civilCode(): string {
      return this.$store.getters['valuationEdit/civilCode']
    },
    coefficientsMap(): {
      [key: string]: { text: string; key: string; hidden?: boolean }
    } {
      return {
        civil_code: {
          text: `Podíl nemovitostí vymezených podle ${this.civilCode}`,
          key: 'civil_code',
        },
        distance: {
          text: 'Mediánová vzdálenost od posuzované nemovitosti',
          key: 'distance',
        },
        furnishings: {
          text: 'Koeficient stavu a vybavení bytu',
          key: 'furnishings',
          hidden: true,
        },
        garage: {
          text: 'Koeficient garáží',
          key: 'garage',
          hidden: true,
        },
        plot_owner: {
          text: 'Úprava ceny pro neshodu vlastníka budovy a pozemku',
          key: 'plot_owner',
        },
        time: {
          text: 'Průměrné roční tempo růstu cen nemovitostí',
          key: 'time',
        },
      }
    },
    items(): Coefficient[] {
      let order = 1
      return Object.keys(this.coefficients)
        .map(coeffKey =>
          getNestedValue(this.coefficientsMap, [coeffKey], undefined)
        )
        .filter(coeff => coeff !== undefined && !coeff.hidden)
        .map(coeff => ({
          order: order++,
          text: coeff.text,
          key: coeff.key,
          status: getNestedValue(
            this.coefficientEdits,
            [coeff.key],
            this.coefficients[coeff.key]
          ),
        }))
    },
  },
  methods: {
    toggleCoefficient(coeff: Coefficient): void {
      this.$store.commit('valuationEdit/addEdit', {
        categoryKey: 'coefficients',
        edit: {
          [coeff.key]: !coeff.status,
        },
      })
    },
  },
})
